/**
 * Client-side validation for lookup field inputs.
 * Client-side validation for resource ID inputs.
 */

const ID_MAX_LENGTH = 128
const ID_PATTERN = /^[A-Za-z0-9_-]+$/

/**
 * Validates a generic resource identifier (fund, entity, instrument, trade, etc.).
 * Accepts letters, numbers, hyphens, and underscores — no spaces or special chars.
 *
 * @param value - Raw input (will be trimmed)
 * @param resourceLabel - Human label used in error copy e.g. "Entity", "Fund"
 */
export function validateGenericId(
	value: string | null | undefined,
	resourceLabel: string,
): { valid: boolean; error?: string } {
	const trimmed = typeof value === "string" ? value.trim() : ""
	if (!trimmed) {
		return { valid: false, error: `Please enter a ${resourceLabel} ID or use the selected cell.` }
	}
	if (trimmed.length > ID_MAX_LENGTH) {
		return { valid: false, error: `${resourceLabel} ID is too long (max ${ID_MAX_LENGTH} characters).` }
	}
	if (!ID_PATTERN.test(trimmed)) {
		return {
			valid: false,
			error: `${resourceLabel} ID can only contain letters, numbers, hyphens, and underscores.`,
		}
	}
	return { valid: true }
}
